module.exports = __webpack_public_path__ + "img/lang-18.c0e4ea8d.jpg";